import Splide from '@splidejs/splide';
import SimpleBar from "simplebar";
import baguetteBox from "baguettebox.js";
import { uaCheck, mq } from "./modules/utils";
import 'baguettebox.js/dist/baguetteBox.min.css';
import '@splidejs/splide/dist/css/splide.min.css';

uaCheck();
mq();

function accArea() {
  $(".acc-btn").on("click", function () {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });
  $("#event .acc-btn").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).children().html("CLOSE");
    } else {
      $(this).children().html("MORE");
    }
  });
}

function smoothScroll() {
  $('a[href^="#"]').on("click", function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href === "#" || href === "" ? "html" : href);
    let position = target.offset().top;

    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
}

function scrollBar() {
  const newslist = document.getElementById("newslist");
  if (newslist) {
    const simpleBarInstance = new SimpleBar(newslist, {
      autoHide: false,
    });
  }
}

function toggleBtn() {
  if (mq("sp")) {
    $(".toggle-btn").on("click", function () {
      $(this).toggleClass("active");
      $(this).next().fadeToggle();
    });
    $("nav a").on("click", function () {
      $(this).parents("nav").fadeOut();
      $(".toggle-btn").removeClass("active");
    });
  }
}

function modal() {
  $(".modal-btn").on("click", function () {
    let id = $(this).attr("id"); // クリックされたボタンのIDを取得
    let modalId = `#modal-area${id.slice(-2)}`; // 対応するモーダルエリアのIDを作成
    $(modalId).fadeIn(); // 対応するモーダルエリアを表示
  });

  $(".modal-area .close-btn, .modal-area").on("click", function () {
    $(this).closest(".modal-area").fadeOut(); // クリックされたモーダルエリアを非表示
  });

  // モーダル内のコンテンツ領域をクリックしても閉じないようにする
  $(".modal-content").on("click", (e) => {
    e.stopPropagation();
  });
}

const imageScale = () => {
  baguetteBox.run(".map-area", {
    animation: "fadeIn",
  });
};

function splideFnc() {
  const splide = new Splide('.splide', {
    type: 'loop',
    perPage: 1,
    arrows: false,
  });

  splide.mount();
}

window.addEventListener("load", () => {
  accArea();
  smoothScroll();
  scrollBar();
  toggleBtn();
  modal();
  imageScale();
  splideFnc();
});
